<div class="flex flex-col w-full min-w-0 sm:inset-0 sm:overflow-hidden">
  <mat-drawer-container class="flex-auto sm:h-full">
    <mat-drawer-content class="h-full">
      <div>
        <div class="flex-auto pl-4 pt-2">
          <div class="w-full mx-auto">
            <mat-tab-group
              [selectedIndex]="selectedIndex"
              (selectedIndexChange)="tabFn($event)"
              class=""
              mat-stretch-tabs="false"
              [animationDuration]="'0'"
            >
              <mat-tab label="All Partners">
                <ng-template matTabContent>
                  <app-all-partners></app-all-partners>
                </ng-template>
              </mat-tab>
              <mat-tab label="Trial Partners">
                <ng-template matTabContent>
                  <app-trial-partners></app-trial-partners>
                </ng-template>
              </mat-tab>
              <mat-tab label="Plan 100 Partners">
                <ng-template matTabContent>
                  <app-plan-partners></app-plan-partners>
                </ng-template>
              </mat-tab>
              <mat-tab label="Paid Partners">
                <ng-template matTabContent>
                  <app-paid-partners></app-paid-partners>
                </ng-template>
              </mat-tab>
              <mat-tab label="Suspended Partners">
                <ng-template matTabContent>
                  <app-suspended-partners></app-suspended-partners>
                </ng-template>
              </mat-tab>
              <!-- <mat-tab label="Cancelled Partners">
                <ng-template matTabContent>
                  <app-cancelled-partners></app-cancelled-partners>
                </ng-template>
              </mat-tab> -->
            </mat-tab-group>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
